export default function AudienceSection() {
  return (
    <section className="relative overflow-hidden" style={{ aspectRatio: "2268/1350" }}>
      <img
        src="https://images.unsplash.com/photo-1744686912094-5a25e7c329b6?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0"
        alt="Bold Creatives audience background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <img
        src="https://images.unsplash.com/photo-1744257980582-db392a250536?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0"
        alt="Bold Creatives audience"
        className="absolute inset-0 w-full h-full object-cover object-top z-10 opacity-60"
      />
    </section>
  );
}
